import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor as BaseEditor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './Editor.scss';

class Editor extends Component {
  constructor(props) {
    super(props);
    this.state = { editorState: EditorState.createEmpty() };
    // Bind
    this.onBlur = this.onBlur.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.content) {
      const blocksFromHtml = htmlToDraft(nextProps.content);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      this.setState({
        editorState: EditorState.createWithContent(contentState)
      });
    } else {
      this.setState({
        editorState: nextProps.content
      });
    }
  }

  onEditorStateChange(editorState) {
    this.setState({
      editorState
    });
    if(typeof this.props.onChange === 'function') this.props.onChange();
  }

  onBlur() {
    this.props.onBlur(
      draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
    );
  }

  render() {
    const { editorState } = this.state;

    return (
      <div dir="ltr">
        <BaseEditor
          editorState={editorState}
          onBlur={this.onBlur}
          onEditorStateChange={this.onEditorStateChange}
          toolbar={{
            options: [
              'textAlign',
              'link',
              'blockType',
              'image',
              'history',
              'inline',
              'list'
            ],
            inline: {
              options: [
                'bold',
                'italic',
                'strikethrough',
                'underline',
                'superscript',
                'subscript'
              ]
            }
          }}
        />
      </div>
    );
  }
}
export default Editor;

Editor.propTypes = {
  content: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func
};
Editor.defaultProps = {
  content: '',
  onBlur: null,
  onChange: null
};
